import { lazy } from "react";
import type { ProductionShellProps } from "./ProductionShell";
const ProductionShell = lazy(() => import("./ProductionShell").then(module => ({ default: module.ProductionShell })));
import { setStudioView } from "../workspace/studio-views";

export function mountProductionShell(
  slot: HTMLElement,
  props: ProductionShellProps,
) {
  setStudioView("production-shell", `production-shell:${props.projectId}`, <ProductionShell key={props.projectId} {...props} />);
}
